import { render } from "./Chat_Message.vue?vue&type=template&id=9a52ad14"
import script from "./Chat_Message.vue?vue&type=script&lang=js"
export * from "./Chat_Message.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__